import _ from 'underscore';

function Ctrl($rootScope, $scope, storage, events, supportService, conciergeState, conciergeMessageReceivedKey) {
  const STATE = conciergeState;
  const CONCIERGE_UNREAD_COUNT_KEY = 'tl_concierge_unread_count';

  $scope.STATE = STATE;
  $scope.checkedMessages = {};
  $scope.pendingUnreadMessages = [];
  $scope.visible = false;

  $scope.unreadMessages = function() {
    return storage.get(CONCIERGE_UNREAD_COUNT_KEY) || 0;
  };

  $scope.state = function() {
    return $rootScope.currentUser ? STATE.CHAT : STATE.SIGNUP;
  };

  $scope.show = function() {
    $scope.visible = true;
    $scope.markPendingMessagesRead();
  };

  $scope.hide = function() {
    $scope.visible = false;
    $scope.markPendingMessagesRead();
  };

  $scope.$on('new-concierge-message', function() {
    if (!$scope.visible) {
      $scope.show();
    }
  });

  $scope.markPendingMessagesRead = function() {
    if ($scope.pendingUnreadMessages.length > 0) {
      const messageIds = _.map($scope.pendingUnreadMessages, 'id');

      supportService.markMessagesRead(messageIds);
    }

    $scope.pendingUnreadMessages = [];

    storage.set(CONCIERGE_UNREAD_COUNT_KEY, 0);
  };

  events.on(conciergeMessageReceivedKey, function(event, message) {
    if (!$scope.visible && $scope.isUnreadMessage(message)) {
      $scope.pendingUnreadMessages.push(message);
      storage.set(CONCIERGE_UNREAD_COUNT_KEY, $scope.unreadMessages() + 1);

    } else if ($scope.visible && $scope.isUnreadMessage(message)) {
      supportService.markMessagesRead([message.id]);
    }
  });

  if ($scope.state() === STATE.CHAT) {
    const options = {
      messageState: ['sent', 'delivered'],
      fields: 'from.userType,to.userType',
      limit: 20
    };

    supportService.listClientMessages(options)
      .then(function(result) {
        result = _.filter(result, $scope.isUnreadMessage);
        $scope.pendingUnreadMessages = result;
        storage.set(CONCIERGE_UNREAD_COUNT_KEY, result.length);
      });
  }

  $scope.isUnreadMessage = function(message) {
    if ($scope.checkedMessages[message.id]) return false;
    $scope.checkedMessages[message.id] = true;
    return message.from.userType === 'agent' && message.to.userType !== 'agent';
  };
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  'tl.storage',
  'tl.ee',
  'tl.support.service',
  'conciergeState',
  'conciergeMessageReceivedKey'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/concierge/controller.js